// The track renders fixed headroom above the target, so the target rule sits at
// the same position on every card (cards stay comparable) and potential planned
// above the ceiling has somewhere to draw.
export const TRACK_TARGET_POSITION_PERCENT = 80;

// Track length as a multiple of target. Derived from the rule position so the
// two can never drift apart.
export const TRACK_SCALE_OF_TARGET = 100 / TRACK_TARGET_POSITION_PERCENT;

// The target field steps in hundreds of thousands: a government allocation is
// quoted in round figures, and single-krone stepping on an eight-digit number is
// unusable.
export const TARGET_STEP_KRONER = 100_000;

// Ties the field's label to its input. One id, because only one of these is ever
// on screen at a time.
export const TARGET_FIELD_ID = 'year-plan-money-target';

// Ties the interim per-browser note to the same input as its description. Goes
// with the note itself when REH-341 replaces the localStorage seam.
export const TARGET_DEVICE_NOTE_ID = 'year-plan-money-target-device-note';

// The highest week number an ISO year can hold. Only used to bound the locked
// week range the card's legend names, so a nonsense figure from the endpoint
// cannot print "weeks 1-9999".
export const MAX_ISO_WEEK = 53;
